module.exports = __webpack_public_path__ + "assets/0d6ba1da2c8478ffd30ca002440c7de5.jpg";